export enum FormTemplateTypeEnum {
    Client = 1,
    Centre = 2,
}